export const regPatternForNumbers = /(^[0-9]{9}$|^$)/;
export const regPatternForAlpha = /^([a-zA-Z])*$/;
export const regPatternForPhoneNumber = "";
export const regPatternForEmail = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
export const regPatternForAlphaNumeric = /^[a-zA-Z0-9 ]*$/;

export const isNumeric = (value) => {
  return regPatternForNumbers.test(value);
};

export const isAlpha = (value) => {
  return regPatternForAlpha.test(value);
};

export const isAlphaNumeric = (value) => {
  return regPatternForAlphaNumeric.test(value);
};

export const isValidEmail = (value) => {
  return regPatternForEmail.test(value);
};

export const prependDuns = (value) => {
  if (value) {
    return value.padStart(9, "0");
  }
  return value;
};

export const formatPhoneNumber = (value, previousValue) => {
  if (!value) return value;
  const currentValue = value.toString().replace(/[^\d]/g, "");
  const cvLength = currentValue.length;
  if (!previousValue || value.length > previousValue.length) {
    if (cvLength < 4) return currentValue;
    if (cvLength < 7)
      return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
    return `(${currentValue.slice(0, 3)}) ${currentValue.slice(
      3,
      6
    )}-${currentValue.slice(6, 10)}`;
  }
};

export const numberFormat = (value) =>
  new Intl.NumberFormat("en-IN", {}).format(value);

export const currencyFormat = (value) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "USD",
  }).format(value);

export const isValidDuns = (value) => regPatternForNumbers.test(value || "");
